// @flow

import React, { type Node } from 'react';
import { useUniqueId } from '@tectonics/hooks';
import { InputMask } from '@tectonics/components/input-mask';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { useUserInputValidationError } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';

import { Input, Label } from '../../../../../commons/atoms';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { Field } from '../../../../../commons/molecules';
import { ValidationErrorMessage } from './validation-error-message';

export function FieldChileanDocument(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();

  const [chileanDocument, handleChangeChileanDocument] = useUserInputAsTextField('chileanDocument');
  const formHasBeenSent = useFormHasBeenSent();
  const validationError = useUserInputValidationError('chileanDocument');

  return (
    <Field
      data-test-name="customer-document"
      label={<Label htmlFor={inputId}>RUT</Label>}
      error={<ValidationErrorMessage validationError={validationError} />}
      hasError={formHasBeenSent && !!validationError}
    >
      <Input
        as={InputMask}
        id={inputId}
        value={chileanDocument}
        onChange={handleChangeChileanDocument}
        mask={RUT_MASK}
        readOnly={submitting}
        placeholder="Ingresa tu RUT"
        type="text"
        name="customer-document"
      />
    </Field>
  );
}

const RUT_MASK = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9K]/i, /[0-9K]/i];
